import {useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import React from 'react'
import {getDomainConfig} from '~/domains'
import {ShopingExplore} from '~/icons/shopping-explore-icon'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'

const SocialProofBanner = () => {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)
  const translations = getTranslation(language)
  return (
    <div className={clsx(stylesBydomain.UTILS_MAIN_CONTAINER, 'mx-auto')}>
      <div
        className={clsx(
          'border-gray relative z-20 flex h-full w-full flex-row items-center justify-between gap-2 overflow-hidden rounded-2xl border px-8 py-5 text-center tablet:flex-col-reverse tablet:px-5',
          stylesBydomain.HOMEPAGE_EXPLORE_BANNER_BG,
          'homepage_explore_banner_bg',
        )}
      >
        <div className="flex w-74 flex-col gap-5 tablet:w-full">
          <span
            className={clsx(
              'text-start text-xl before:content-["★"] tablet:text-center',
              stylesBydomain.HOMEPAGE_EXPLORE_BANNER_TEXT,
              stylesBydomain.HOMEPAGE_EXPLORE_BANNER_TEXT_STAR,
              'homepage_explore_banner_text',
            )}
          >
            &nbsp;{translations.Home.SocialProofBanner.title}
          </span>
        </div>
        <ShopingExplore
          className={clsx('shrink-0', stylesBydomain.HOMEPAGE_EXPLORE_BANNER_ICONS, 'homepage_explore_banner_icons')}
        />
      </div>
    </div>
  )
}

export default SocialProofBanner
